<template lang="html">
  <main id="qr-page" class="qr-page bg-white min-vh-100">
    <!-- Loading -->
    <div
      v-if="isLoading"
      class="qr-page__loading d-flex min-vh-100 align-items-center justify-content-center bg-white"
    >
      <div class="text-center">
        <div class="qr-page__spinner border border-dark rounded-circle mb-3 mx-auto"></div>
        <p class="text-muted text-uppercase mb-0 qr-page__label-loading">Loading</p>
      </div>
    </div>

    <template v-else>
      <!-- Header -->
      <header class="qr-page__header sticky-top border-bottom border-dark bg-dark">
        <div class="container-fluid px-4 py-4 d-flex align-items-center justify-content-center">
          <a href="/" class="d-inline-block">
            <img
              :src="logoUrl"
              alt="Legacy Timepieces"
              class="qr-page__logo img-fluid"
            >
          </a>
        </div>
      </header>

      <!-- Galería -->
      <div
        class="qr-page__section qr-transition qr-gallery"
        :class="{ 'is-visible': showContent }"
      >
        <watch-gallery :images="product.images" />
      </div>

      <!-- Detalle producto -->
      <div class="container-fluid px-4 pb-5 pt-4 pt-md-5">
        <div
          class="qr-page__section qr-transition qr-transition--delay-1"
          :class="{ 'is-visible': showContent }"
        >
          <div class="border-bottom pb-4 mb-4 mb-sm-5">
            <h1 class="qr-page__title h4 font-weight-light text-dark mb-sm-4">
              {{ product.name }}
            </h1>
            <!-- <div class="d-flex align-items-baseline flex-wrap">
              <p class="h4 font-weight-light text-dark mb-0 mr-2">
                {{ formattedPrice }}
              </p>
              <span class="text-muted text-uppercase small qr-page__spec-label">{{ product.currency }}</span>
            </div> -->
          </div>

          <div class="mb-5">
            <div class="row mb-4">
              <div class="col-6">
                <p class="text-muted text-uppercase mb-2 qr-page__spec-label">Brand</p>
                <p class="text-dark mb-0 qr-page__spec-value">{{ product.brand }}</p>
              </div>
              <div class="col-6">
                <p class="text-muted text-uppercase mb-2 qr-page__spec-label">Reference</p>
                <p class="text-dark mb-0 qr-page__spec-value">{{ product.reference_number }}</p>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-6">
                <p class="text-muted text-uppercase mb-2 qr-page__spec-label">Materials</p>
                <p class="text-dark mb-0 qr-page__spec-value">{{ product.materials }}</p>
              </div>
              <div class="col-6">
                <p class="text-muted text-uppercase mb-2 qr-page__spec-label">Diameter</p>
                <p class="text-dark mb-0 qr-page__spec-value">{{ product.sizes }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <p class="text-muted text-uppercase mb-2 qr-page__spec-label">Condition</p>
                <p class="text-dark mb-0 qr-page__spec-value">
                  <span v-if="product.used_new == 'Used'">Pre owned </span>
                  <span v-if="product.used_new == 'New'">New </span>
                </p>
              </div>
              <!-- <div class="col-6">
                <p class="text-muted text-uppercase mb-2 qr-page__spec-label">Includes</p>
                <div class="text-dark qr-page__spec-value">
                  <div v-for="(line, i) in product.includes" :key="'inc-' + i">{{ line }}</div>
                </div>
              </div> -->
            </div>
          </div>

          <div class="bg-light px-4 py-4 mt-4 mx-n4">
            <h2 class="text-dark text-uppercase mb-3 qr-page__spec-label">Description</h2>
            <p class="text-muted text-justify mb-0 font-weight-light qr-page__description" v-html="product.description"></p>
          </div>
        </div>

        <!-- Botones -->
        <div
          class="qr-page__section qr-transition qr-transition--delay-2 px-0 pb-4 pt-3"
          :class="{ 'is-visible': showContent }"
        >
          <!-- <a
            :href="'mailto:' + contactEmail"
            class="btn btn-block qr-page__btn qr-page__btn--muted mb-3"
          >
            <i class="fas fa-envelope mr-2" aria-hidden="true"></i>
            Contact Your Seller
          </a> -->

          <a class="btn btn-block qr-page__btn qr-page__btn--muted mb-3" @click="toContact">
            <i class="fas fa-envelope mr-2" aria-hidden="true"></i>
            Contact Your Seller
          </a>
          <router-link
            to="/"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-block qr-page__btn qr-page__btn--outline"
          >
            <i class="fas fa-external-link-alt mr-2" aria-hidden="true"></i>
            More Pieces
          </router-link>
        </div>
      </div>

      <!-- Footer -->
      <footer
        class="qr-page__section qr-transition qr-transition--delay-2 border-top py-5 text-center"
        :class="{ 'is-visible': showContent }"
      >
        <p class="text-muted text-uppercase mb-0 qr-page__footer-brand">Legacy Timepieces</p>
      </footer>
    </template>
  </main>
</template>

<script>
import WatchGallery from './WatchGallery.vue';

export default {
  name: 'QrPage',

  components: {
    WatchGallery,
  },

  data() {
    return {
      isLoading: true,
      id: null,
      showContent: false,
      logoUrl:
        'public/images/logo.png',
      contactEmail: 'info@legacytimepieces.com',
      galleryImages: [
        // '/public/images/pages/products/image-NHNlsYgWNWFoVJth7lg7zS9UZaR1zJ.png',
        // '/public/images/pages/products/image-NHNlsYgWNWFoVJth7lg7zS9UZaR1zJ.png',
      ],
      product: {
        // title: 'Oyster Perpetual 41mm SS / Black Dial',
        // price: 10500,
        // currency: 'USD',
        // brand: 'ROLEX',
        // reference: '124300',
        // materials: 'Stainless Steel',
        // diameter: '41MM',
        // condition: 'New',
        // includes: ['Box', 'Certificate'],
        // description:
        //   'Oyster Perpetual, New Model for 2020, stainless steel on a stainless steel oyster bracelet, automatic 3230 Rolex movement, 70-hour power reserve, centered sweep seconds hand, black dial with white stick markers, COSC, diameter: 41mm, thickness: 11.8mm, sapphire crystal, scrambled serial, water resistant to 30m / 100ft.',
      },
    };
  },

  methods: {
    toContact(){
      this.$router.push('/contacto?data='+this.product.name+'- REFERENCE: '+this.product.reference_number);
    },

    getRow(){
      this.isLoading = true;
      // axios.get("https://legacytimepieces.com.mx/api/product/"+this.id).then((response)=>{
        axios.get(tools.url("/api/product/"+this.id)).then((response)=>{
			    this.product = response.data.row;
          this.isLoading = false;
			  }).catch((error)=>{
          // this.$root.isLoading = false;
			  });
    },
  },

  computed: {
    formattedPrice() {
      return (
        '$' +
        new Intl.NumberFormat('en-US', { minimumFractionDigits: 0 }).format(this.product.price)
      );
    },
  },

  mounted() {
    const loadingMs = 600;
    this._loadingTimer = setTimeout(() => {
      this.isLoading = false;
      this.$nextTick(() => {
        setTimeout(() => {
          this.showContent = true;
        }, 50);
      });
    }, loadingMs);

    this.id = this.$route.params.id;
    this.getRow()
  },

  beforeDestroy() {
    if (this._loadingTimer) {
      clearTimeout(this._loadingTimer);
    }
  },

  watch:{
    '$route.params.id':function(){
      this.id = this.$route.params.id;
      this.getRow();
    }
  }  
};
</script>
